/* eslint-disable no-restricted-globals */
// Section id targeted by the current URL hash, e.g. links from client reports
// pointing to "/opportunity/:id#opportunity_detail_page.anchor_navigation.investor_report"
export const getHashTargetId = (): string => {
  const hash = location.hash.slice(1);

  try {
    return decodeURIComponent(hash);
  } catch (e) {
    return hash;
  }
};
